import instantVoiceClonesFeatures from './InstantVoiceClones';
import monetizeCommunityVoicesFeatures from './MonetizeCommunityVoices';
import professionalVoiceClonesFeatures from './ProfessionalVoiceClones';
import publishVoicesCommunityFeatures from './PublishVoicesCommunity';
import purchaseAdditionalProVoiceFeatures from './PurchaseAddtionalProVoice';

const voiceCloningFeatures = ({ packages, activeGranularity }) => ({
  instantVoiceClones: {
    key: 'instant-voice-clones',
    label: 'instantVoiceClones',
    values: instantVoiceClonesFeatures({ packages }),
  },
  professionalVoiceClones: {
    key: 'professional-voice-clones',
    label: 'professionalVoiceClones',
    values: professionalVoiceClonesFeatures({ packages }),
  },
  purchaseAdditionalProVoice: {
    key: 'purchase-additional-pro-voice',
    label: 'purchaseAdditionalProVoice',
    values: purchaseAdditionalProVoiceFeatures({ packages }),
  },
  publishVoicesCommunity: {
    key: 'publish-voices-community',
    label: 'publishVoicesToTheCommunity',
    values: publishVoicesCommunityFeatures({ packages, activeGranularity }),
  },
  monetizeCommunityVoices: {
    key: 'monetize-community-voices',
    label: 'monetizeCommunityVoices',
    values: monetizeCommunityVoicesFeatures({ packages, activeGranularity }),
  },
});

export default voiceCloningFeatures;
